import React, { useState, Fragment, useEffect } from 'react';

import ModalContentWrapper from "../ModalContentWrapper";
import { getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {createUserModal, deleteUser, getUserDetails, requestUserPasswordReset, updateUserDetails} from "root/DataFunctions/UserDataFns";

import '../TwoColumnModal.scss';
import SpinnerDiv from "ui/SpinnerDiv";

import {useForm} from "react-hook-form";

import {SaveButton} from "root/Modals/SaveButton";

import "react-toggle/style.css";
import './ModalUser.scss' ;

import {UserTypes} from "root/DataFunctions/Constants";
import {Tab, Tabs} from "react-bootstrap";
import TablePupils from "root/School/TablePupils";

import {ModalUserModes, userRecord} from "./ModalUserConstants";

import FormFragmentUserDetails from "./FormFragmentUserDetails";

export const FETCH_REQUIRED_MODES = new Set([ModalUserModes.EDIT, ModalUserModes.DELETE, ModalUserModes.VIEW, ModalUserModes.RESET_PASSWORD]);
export const READ_ONLY_MODES = new Set([ModalUserModes.DELETE, ModalUserModes.VIEW, ModalUserModes.RESET_PASSWORD]);
export const IN_SCHOOL_TYPES = new Set([UserTypes.DESI_TEACHER, UserTypes.ATTENDANCE_OFFICER]);

const ROLE_TEXT = {
    [UserTypes.ESW]: 'Education Support Worker',
    [UserTypes.ATTENDANCE_OFFICER]: 'School Attendance Officer',
    [UserTypes.DESI_TEACHER]: 'Designated Teacher',
    [UserTypes.CAREERS_ADVISOR]: 'Careers Advisor',
};

const errStyle = {
    marginTop: '10px',
    fontSize: 'larger',
    color: 'var(--s360-icon-red)',
    fontWeight: 'bold',
};

const saveButtonLabel = ( mode ) =>
{
    switch (mode)
    {
        case ModalUserModes.RESET_PASSWORD:
            return "Reset Password";
        case ModalUserModes.DELETE:
            return "Delete User";
        default:
            return "Save";
    }
};
const ModalUser = ({mode, user_id, user_type, onSaveCompleted, onClose}) =>
{
    const {register, control, handleSubmit, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                user: userRecord(null, user_type)
            }
        });

    const [data, setData] = useState({ isLoading: true, data: [] });

    const [buttonsDisabled, setButtonsDisabled] = useState(false);

    useEffect(() =>
    {
        if (FETCH_REQUIRED_MODES.has(mode))
        {
            getUserDetails(user_id, ['include-assignments'], (response) =>
            {
                const userData = getDataFromResponse(response)[0];

                setValue('user', userRecord(userData, user_type));

                setData({ isLoading: false, data: userData });
            });
        }
        else if (mode === ModalUserModes.CREATE)
        {
            setData({ isLoading: false, data: [] });
        }

    }, [user_id]);

    const onClickCancel = () =>
    {
        onSaveCompleted('cancel');
        onClose();
    };
    const onSubmit = (data) =>
    {
        setButtonsDisabled(true);

        switch (mode)
        {
            case ModalUserModes.EDIT:
                updateUserDetails(user_id, 'update', data, () =>
                {
                    onSaveCompleted('saved');
                    onClose();
                });
                break;
            case ModalUserModes.CREATE:
                createUserModal(user_type, data, () =>
                {
                    onSaveCompleted('saved');
                    onClose();
                });
                break;
            case ModalUserModes.RESET_PASSWORD:
                requestUserPasswordReset(user_id, () =>
                {
                    onSaveCompleted('cancel');
                    onClose();
                });
                break;
            case ModalUserModes.DELETE:
                deleteUser(user_id, user_type, () =>
                {
                    onSaveCompleted('saved');
                    onClose();
                });
                break;
            default:
                throw new Error('Invalid mode on save');
        }
    };



    const assignedChildCount = data.data?.assigned_children?.length ?? 0;

    const showActionButton = () =>
    {
        if (mode === ModalUserModes.CREATE) return true;

        if (mode === ModalUserModes.DELETE && assignedChildCount !== 0) return false;

        return true;
    };

    const message = () =>
    {
        if (mode === ModalUserModes.DELETE && assignedChildCount > 0)
        {
            return <div style={errStyle}>{`You cannot delete this user as they still have ${assignedChildCount} assigned pupils`}</div>;
        }
    };
    const renderForm = () =>
    {
        const readOnlyMode = READ_ONLY_MODES.has(mode);
        const isInSchool = IN_SCHOOL_TYPES.has(user_type);
        const isAttendanceOfficer = isInSchool && data.data.school?.school_attendance_officer_id !== null;

        return (
            <div className='buy-card-right modal-school-form' style={{marginBottom: '20px', marginTop: '20px'}}>
                <form className='' onSubmit={handleSubmit(onSubmit)}>

                    <FormFragmentUserDetails mode={mode} user_type={user_type} isAttendanceOfficer={isAttendanceOfficer} readOnly={ readOnlyMode } formErrors={formErrors} sectionName='user' register={register} control={control} />

                </form>

                {message()}

                <div className='card-button-line'>
                    <div><button onClick={onClickCancel} className="btn btn-icon btn-secondary btn-icon-right btn-small">Cancel<i className="et-arrow-bold-left"></i></button></div>
                    <div>{showActionButton() && <SaveButton onClick={handleSubmit(onSubmit)} disabled={buttonsDisabled}>{saveButtonLabel(mode)}</SaveButton>}</div>
                </div>
            </div>
        );
    };

    const title = () =>
    {
        switch (mode)
        {
            case ModalUserModes.EDIT:
                return <h3>Amend User Details</h3>;
            case ModalUserModes.CREATE:
                return <h3>{'Create ' + (ROLE_TEXT[user_type] ?? 'User')}</h3>;
            case ModalUserModes.DELETE:
                return <h3>Delete User</h3>;
            case ModalUserModes.RESET_PASSWORD:
                return <h3>Request User Password Reset</h3>;
            default:
                return <h3>User</h3>;
        }
    };

    const assigned_children = data.data?.assigned_children ?? [];

    return (
        <ModalContentWrapper className="modal-wrapper" columns={2} width={'800px'}>
            {title()}
            <div className='buy-card'>
                <div>
                    <span className='glyphicon glyphicon-user' style={{color: 'var(--vschool-mild-blue)', fontSize: '8rem', marginTop: '30px'}} />
                </div>
                <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
                    <Tab eventKey={1} title="User Details">
                        {data.isLoading ? (
                            <div style={{ textAlign: 'center', color: 'var(--vschool-mild-blue)', marginTop: '10px'}}>
                                <h4>Loading User</h4>
                                <SpinnerDiv/>
                            </div>
                        ) : renderForm()}
                    </Tab>
                    {mode !== ModalUserModes.CREATE && <Tab eventKey={2} title="Assigned Pupils" style={{minHeight: '475px'}}>
                        <div style={{marginTop: '10px'}}>
                            <TablePupils loading={data.isLoading} data={assigned_children} />
                        </div>
                    </Tab>}
                </Tabs>
            </div>
        </ModalContentWrapper>
    );
};

export default ModalUser;